import { BookOpen, KeyRound, Webhook as WebhookIcon } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { NoOpsSelected } from '../../components';
import { PageTabsList, PageTabsTrigger, Tabs, TabsContent } from '../../components/ui/tabs';
import { useOps } from '../../hooks/useOps';
import { Credenciais } from './credenciais/Credenciais';
import { ApiDocs } from './docs/ApiDocs';
import { Webhook } from './webhook/Webhook';

// Tela "API": documentação da ApiForClient e, com permissão, credenciais e
// webhook da ops atual. Aba e seção da documentação ficam na URL (?aba=&secao=).
export function ApiGestao() {
  const { currentOps } = useOps();
  const { hasPermission } = useAuth();
  const [params, setParams] = useSearchParams();

  if (!currentOps) {
    return <NoOpsSelected message="Selecione uma operação para ver a API." />;
  }

  const abas = [
    'documentacao',
    ...(hasPermission('apiForClientCredenciais', currentOps) ? ['credenciais'] : []),
    ...(hasPermission('apiForClientWebhook', currentOps) ? ['webhook'] : []),
  ];
  const aba = abas.includes(params.get('aba') ?? '') ? params.get('aba')! : 'documentacao';

  const irPara = (novaAba: string, secao?: string) => {
    const novos = new URLSearchParams(params);
    novos.set('aba', novaAba);
    if (secao) novos.set('secao', secao);
    setParams(novos);
  };

  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold text-[hsl(210,50%,10%)]">API</h1>
        <p className="text-sm text-[hsl(215,16%,47%)]">
          Integre o sistema da sua operação com a Planalto.
        </p>
      </div>

      <Tabs value={aba} onValueChange={(v) => irPara(v)}>
        <PageTabsList>
          <PageTabsTrigger value="documentacao">
            <BookOpen className="h-4 w-4" />
            Documentação
          </PageTabsTrigger>
          {abas.includes('credenciais') && (
            <PageTabsTrigger value="credenciais">
              <KeyRound className="h-4 w-4" />
              Credenciais
            </PageTabsTrigger>
          )}
          {abas.includes('webhook') && (
            <PageTabsTrigger value="webhook">
              <WebhookIcon className="h-4 w-4" />
              Webhook
            </PageTabsTrigger>
          )}
        </PageTabsList>
        <TabsContent value="documentacao">
          <ApiDocs />
        </TabsContent>
        {abas.includes('credenciais') && (
          <TabsContent value="credenciais">
            <Credenciais />
          </TabsContent>
        )}
        {abas.includes('webhook') && (
          <TabsContent value="webhook">
            <Webhook verDocumentacao={() => irPara('documentacao', 'webhook')} />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
